// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';

import { useDomainBundle } from '../modules';

import styles from '../PriceArea/Price.scss';

export function CommercialDesciption(): React.MixedElement {
  const { __ } = useTranslator();

  const { formattedDiscountPercent } = useDomainBundle();

  return (
    <Base flex flexCol gap="xxsmall" marginBottom="xsmall">
      <Text weight="semibold" className={styles.discountPrice}>
        {__('Save %(percent)s by purchasing these domains together!', {
          percent: formattedDiscountPercent,
        })}
      </Text>
      <Text>
        {__('Opt for a bundle and strengthen your brand protection.')}
      </Text>
    </Base>
  );
}
